"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitUntil = waitUntil;
const rxjs_1 = require("rxjs");
/**
 * Operator that waits until the notifier observable emits.
 * Useful if you only want to begin emitting after another observable has emitted
 *
 * Unlike @skipUntil (https://rxjs.dev/api/operators/skipUntil) this emits the latest source$ value when notifier$ emits
 *
 * @param notifier$ when this fires, stop waiting and emit latest source$ value
 */
function waitUntil(notifier$) {
    return (source$) => (0, rxjs_1.combineLatest)([notifier$.pipe((0, rxjs_1.take)(1)), source$]).pipe((0, rxjs_1.map)(([_, source]) => source));
}
